(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["legal-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var modal = document.querySelector('[data-legal-modal]');
    if (!modal) return;

    var body = modal.querySelector('[data-legal-modal-body]');
    var panel = modal.querySelector('[role="dialog"]');
    var lastFocusedElement = null;

    function open(handle) {
      var template = document.querySelector('template[data-legal-page="' + handle + '"]');
      if (!template || !body) return false;

      body.innerHTML = '';
      body.appendChild(template.content.cloneNode(true));

      lastFocusedElement = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('legal-modal-open');

      var closeButton = modal.querySelector('[data-legal-modal-close]');
      if (closeButton) {
        closeButton.focus();
      } else if (panel) {
        panel.focus();
      }

      document.addEventListener('keydown', onKeydown);
      return true;
    }

    function close() {
      modal.hidden = true;
      document.body.classList.remove('legal-modal-open');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocusedElement) lastFocusedElement.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        close();
        return;
      }

      if (event.key === 'Tab' && panel) {
        var focusable = Array.prototype.slice.call(
          panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
        );
        if (!focusable.length) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-legal-page]');
      if (link) {
        var opened = open(link.getAttribute('data-legal-page'));
        if (opened) event.preventDefault();
        return;
      }

      if (event.target.closest('[data-legal-modal-close]') || event.target.closest('[data-legal-modal-overlay]')) {
        close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var modal = document.querySelector('[data-size-guide-modal]');
    if (!modal) return;

    var body = modal.querySelector('[data-size-guide-modal-body]');
    var panel = modal.querySelector('[data-size-guide-modal-panel]');
    var lastFocusedElement = null;

    function open(key) {
      var template = document.querySelector('template[data-size-guide="' + key + '"]');
      if (!template || !body || !panel) return false;

      body.innerHTML = '';
      body.appendChild(template.content.cloneNode(true));

      var heading = body.querySelector('h2[id]');
      if (heading) {
        panel.setAttribute('aria-labelledby', heading.id);
      } else {
        panel.removeAttribute('aria-labelledby');
      }

      lastFocusedElement = document.activeElement;
      modal.hidden = false;
      document.body.classList.add('size-guide-modal-open');

      var closeButton = modal.querySelector('[data-size-guide-modal-close]');
      if (closeButton) {
        closeButton.focus();
      } else {
        panel.focus();
      }

      document.addEventListener('keydown', onKeydown);
      return true;
    }

    function close() {
      modal.hidden = true;
      document.body.classList.remove('size-guide-modal-open');
      document.removeEventListener('keydown', onKeydown);
      if (lastFocusedElement) lastFocusedElement.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape' || event.key === 'Esc') {
        close();
        return;
      }

      if (event.key === 'Tab' && panel) {
        var focusable = Array.prototype.slice.call(
          panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
        );
        if (!focusable.length) return;

        var first = focusable[0];
        var last = focusable[focusable.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-size-guide-trigger]');
      if (trigger) {
        event.preventDefault();
        open(trigger.getAttribute('data-size-guide-trigger'));
        return;
      }

      if (
        event.target.closest('[data-size-guide-modal-close]') ||
        event.target.closest('[data-size-guide-modal-overlay]')
      ) {
        close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
